document.addEventListener('DOMContentLoaded', function () {
  // Modal controllers
  window.showMembershipPopup = function (message) {
    const popup = document.getElementById('membership-error-popup');
    const messageEl = document.getElementById('membership-error-message');

    if (!popup || !messageEl) return;

    messageEl.textContent = message;
    popup.classList.add('active');
  };

  window.closeMembershipPopup = function () {
    const popup = document.getElementById('membership-error-popup');
    if (!popup) return;
    popup.classList.remove('active');
  };

  document.addEventListener('click', function (e) {
    if (e.target.closest('.membership-error-popup__close') || e.target.id === 'membership-error-popup' || e.target.closest('.membership-error-popup__keep')) {
      window.closeMembershipPopup();
    }
  });
  function isCartPage() {
    const urlParams = new URLSearchParams(window.location.search);
    const abCart = urlParams.get('ab_cart');
    const cartTest = urlParams.get('cart_test');

    // 1. Explicitly forced by URL param
    if (abCart === 'page' || cartTest === 'page') {
      return true;
    }
    if (abCart === 'drawer' || cartTest === 'drawer') {
      return false;
    }

    // 2. Check if currently on /cart URL (or /de/cart, /nl/cart, etc.)
    const pathname = window.location.pathname;
    return pathname.endsWith('/cart') ||
      pathname.includes('/cart/') ||
      document.body.classList.contains('cart_page') ||
      document.body.classList.contains('template-cart');
  }

  // Handle "Continue to subscription" CTA
  document.addEventListener('click', async function (e) {
    const continueBtn = e.target.closest('.membership-error-popup__continue');
    if (!continueBtn) return;
    e.preventDefault();

    if (continueBtn.disabled) return;
    continueBtn.disabled = true;
    continueBtn.style.opacity = '0.6';

    try {
      // 1. Fetch current cart
      const cart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
      const updates = {};
      let hasMembershipToRemove = false;

      if (cart && cart.items) {
        cart.items.forEach(function (item) {
          const isMembership = item.variant_id === 58584507810117 ||
            item.product_id === 58584507810117 ||
            item.handle === 'plenny-club-membership' ||
            (item.properties && (item.properties._membership_main_prd === 'true' || item.properties._membership_main_prd === true));

          // Match the membership gift by its properties only; variant 57585308926277 is also sold as a paid item.
          const isGift = (item.properties && (
              item.properties._membership_gift_prd === 'true' ||
              item.properties._membership_gift_prd === true ||
              item.properties._membership_gift === 'true' ||
              item.properties._membership_gift === true
            ));

          if (isMembership || isGift) {
            updates[item.key] = 0; // Set quantity to 0
            hasMembershipToRemove = true;
          }
        });
      }

      // 2. Remove membership & its free gift from cart
      if (hasMembershipToRemove) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }

      // 3. UPGRADE THAT CLICKED PRODUCT TO SUBSCRIPTION:
      const pending = window.pendingSubscriptionSwitch;
      const cartItemsElement = document.querySelector('cart-items');
      const sections = (cartItemsElement && typeof cartItemsElement.getSectionsToRender === 'function')
        ? cartItemsElement.getSectionsToRender().map((s) => s.section)
        : [];

      let parsedState = null;
      if (pending && pending.planId) {
        const changePayload = {
          quantity: pending.quantity || 1,
          selling_plan: pending.planId
        };
        // Supports both line item key (drawer) or line number (cart page)
        if (pending.key) {
          changePayload.id = pending.key;
        } else if (pending.line) {
          changePayload.line = pending.line;
        }
        if (sections.length > 0) {
          changePayload.sections = sections;
          changePayload.sections_url = window.location.pathname;
        }

        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(changePayload)
        });
        parsedState = await res.json();
      }

      // 4. Close popup
      window.closeMembershipPopup();

      // 5. Context-aware Refresh: Cart Page vs. Cart Drawer
      if (isCartPage()) {
        // ON CART PAGE: Do like cart.js (no page reload)
        if (cartItemsElement && parsedState && parsedState.sections && typeof cartItemsElement.getSectionsToRender === 'function') {
          cartItemsElement.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                cartItemsElement.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          });
        }

        if (typeof window.cartFallback === 'function') {
          window.cartFallback();
        }
        if (typeof window.fetchCart === 'function') {
          window.fetchCart();
        }
        if (typeof window.shippingCharges === 'function') {
          window.shippingCharges();
        }
        if (typeof window.checkout === 'function') {
          window.checkout();
        }
        if (typeof window.updateFreeShippingCartPage === 'function') {
          window.updateFreeShippingCartPage();
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } else if (window.JJCartDrawerAB && typeof window.JJCartDrawerAB.syncAndRefresh === 'function') {
        // IN DRAWER / OTHER PAGES: Refresh & open cart drawer
        await window.JJCartDrawerAB.syncAndRefresh();
        if (typeof window.JJCartDrawerAB.open === 'function') {
          window.JJCartDrawerAB.open();
        }
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (err) {
      console.error('Error upgrading to subscription:', err);
    } finally {
      continueBtn.disabled = false;
      continueBtn.style.opacity = '';
    }
  });


  document.addEventListener('keydown', function (e) {
    const popup = document.getElementById('membership-error-popup');
    if (e.key === 'Escape' && popup?.classList.contains('active')) {
      window.closeMembershipPopup();
    }
  });

  // Check if A/B Cart Drawer variant is active (ab_cart=drawer)
  // function isAbCartDrawer() {
  //   if (typeof window.isCartDrawerVariant === 'function') {
  //     return window.isCartDrawerVariant();
  //   }
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const abCart = urlParams.get('ab_cart');
  //   const cartTest = urlParams.get('cart_test');

  //   if (abCart === 'drawer' || cartTest === 'drawer') {
  //     try {
  //       document.cookie = "jj_ab_cart_drawer=variant_b; path=/; max-age=2592000";
  //     } catch (e) { }
  //     return true;
  //   }

  //   if (abCart === 'page' || cartTest === 'page') {
  //     try {
  //       document.cookie = "jj_ab_cart_drawer=variant_a; path=/; max-age=2592000";
  //     } catch (e) { }
  //     return false;
  //   }

  //   if (document.body.classList.contains('cart-drawer-ab') || (window.jQuery && window.jQuery('body').hasClass('cart-drawer-ab'))) {
  //     return true;
  //   }

  //   if (document.cookie.indexOf('jj_ab_cart_drawer=variant_b') !== -1) {
  //     return true;
  //   }

  //   return false;
  // }
  function isAbCartDrawer() {
    if (typeof window.isCartDrawerVariant === 'function') {
      return window.isCartDrawerVariant();
    }
    // const urlParams = new URLSearchParams(window.location.search);
    // const abCart = urlParams.get('ab_cart');
    // const cartTest = urlParams.get('cart_test');
    // return abCart === 'drawer' || cartTest === 'drawer';
    return true;
  }


  // Redirect to cart page (control / non-drawer variant)
  function redirectToCart() {
    let cartUrl = '/cart';
    if (window.routes && window.routes.cart_url) {
      cartUrl = window.routes.cart_url;
    } else if (window.currentPath === 'nl') {
      cartUrl = '/nl/cart';
    } else if (window.currentPath === 'de') {
      cartUrl = '/de/cart';
    }
    window.location.href = cartUrl;
  }

  // Dismiss PDP modal and open the cart drawer (only when ab_cart=drawer)
  function openCartDrawerAndDismissModal() {
    document.body.classList.add('cart-drawer-ab');

    // 1. Hide PDP popup modal if open
    const pdpModal = document.getElementById('js-product-addtocart-modal') || document.getElementById('pdppopup');
    if (pdpModal) {
      if (window.jQuery) {
        try { window.jQuery(pdpModal).modal('hide'); } catch (err) { }
      }
      pdpModal.classList.remove('in', 'show');
      pdpModal.style.display = 'none';
    }
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    // 2. Open Cart Drawer via controller if available
    if (window.JJCartDrawerAB && typeof window.JJCartDrawerAB.open === 'function') {
      window.JJCartDrawerAB.open();
      if (typeof window.JJCartDrawerAB.syncAndRefresh === 'function') {
        window.JJCartDrawerAB.syncAndRefresh();
      }
    } else {
      // Direct DOM fallback
      const drawer = document.getElementById('JJ-CartDrawer-AB');
      if (drawer) {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
      }
    }

    // 3. Fallback for native Shopify cart drawer component if present
    const nativeDrawer = document.querySelector('cart-drawer');
    if (nativeDrawer && typeof nativeDrawer.open === 'function') {
      nativeDrawer.open();
    }

    // 4. Dispatch global refresh events so counts and cart items update
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (window.jQuery) {
      window.jQuery(document).trigger('cart:refresh');
    }
  }

  // Route success or existing state: Drawer if ab_cart=drawer, otherwise redirect to Cart page
  function handleSuccessOrExisting() {
    if (isAbCartDrawer()) {
      openCartDrawerAndDismissModal();
    } else {
      redirectToCart();
    }
  }

  // Global Concurrency Guard
  let isProcessing = false;

  const targetSelector = '.plenny-club__button, .membership-value__button, .responsive-image-content-card__button, .club-membership-offer__cta';

  // Event handler for adding membership
  async function handleMembershipClick(e, button) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    // Prevent double clicking & duplicate parallel requests
    if (isProcessing) return;
    isProcessing = true;

    if (button) {
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.6';
    }

    function resetButton() {
      isProcessing = false;
      if (button) {
        button.style.pointerEvents = '';
        button.style.opacity = '';
      }
    }

    const membershipVariantId = Number(window.main_product) || 58584507810117;
    const giftVariantId = 57585308926277;

    try {
      // Step 1: Pre-check cart. If membership is ALREADY in cart, don't re-add (prevents 422 error)
      let currentCart = null;
      try {
        currentCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
      } catch (err) { }

      const hasMembership = currentCart && currentCart.items && currentCart.items.some(item =>
        Number(item.variant_id) === membershipVariantId ||
        Number(item.id) === membershipVariantId ||
        (item.properties && (item.properties._membership_main_prd === 'true' || item.properties._membership_main_prd === true))
      );

      if (hasMembership) {
        handleSuccessOrExisting();
        resetButton();
        return;
      }

      // Step 2: Not in cart yet -> Add membership + free gift
      const items = [
        {
          id: membershipVariantId,
          quantity: 1,
          properties: {
            '_membership_main_prd': 'true',
            '_membership_birthday': window.birthday || ''
          }
        },
        {
          id: giftVariantId,
          quantity: 1,
          parent_id: membershipVariantId,
          properties: {
            'Free Gift': '✓',
            '_membership_gift_prd': 'true',
            '_membership_gift': 'true'
          }
        }
      ];

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      const result = await response.json().catch(() => ({}));
      const pathcheck = window.currentPath;

      // Step 3: Handle responses
      if (!response.ok) {
        // If 422 "Only one membership can be purchased per order.",
        // it means the membership is already in cart! Treat as success: open drawer if ab_cart=drawer, else redirect to cart
        if (result.status == '422' && (result.message === "Only one membership can be purchased per order." || (result.message && result.message.indexOf('Only one membership') !== -1))) {
          if(pathcheck == "de"){
              window.showMembershipPopup("Füge ein Plenny Produkt hinzu, um deine Mitgliedschaft zu aktivieren.");
          }else if(pathcheck == "nl"){
              window.showMembershipPopup("Voeg een Plenny product toe om je lidmaatschap te activeren.");
          }else{
              window.showMembershipPopup("Add at least one Plenny product to unlock the membership.");
          }
          handleSuccessOrExisting();
          resetButton();
          return;
        }

        // Legitimate error messages
        if (result.status == '422' && result.message == "Add at least one other product to purchase the membership.") {
          if (pathcheck == "de") {
            window.showMembershipPopup("Füge ein Plenny Produkt hinzu, um deine Mitgliedschaft zu aktivieren.");
          } else if (pathcheck == "nl") {
            window.showMembershipPopup("Voeg een Plenny product toe om je lidmaatschap te activeren.");
          } else {
            window.showMembershipPopup("Add at least one Plenny product to unlock the membership.");
          }
        } else if (result.status == '422' && result.message == "Membership cannot be purchased with subscription products.") {
          if (pathcheck == "de") {
            window.showMembershipPopup("Eine Mitgliedschaft und ein Abonnement können nicht in derselben Bestellung erworben werden.");
          } else if (pathcheck == "nl") {
            window.showMembershipPopup("Een lidmaatschap en een abonnement kunnen niet tegelijk worden aangeschaft.");
          } else {
            window.showMembershipPopup("Membership cannot be purchased with subscription products. Remove the subscription item or switch it to a one-time purchase.");
          }
        } else if (result.status == '422' && result.message == "Your membership is already active.") {
          if (pathcheck == "de") {
            window.showMembershipPopup("Deine Mitgliedschaft ist bereits aktiv.");
          } else if (pathcheck == "nl") {
            window.showMembershipPopup("Je lidmaatschap is al actief.");
          } else {
            window.showMembershipPopup("Your membership is already active.");
          }
        } else if (result.status == '422' && result.message == "Discounts cannot be applied to the membership fee.") {
            if(pathcheck == "de"){
                window.showMembershipPopup("Discounts cannot be applied to the membership fee.");
            }else if(pathcheck == "nl"){
                window.showMembershipPopup("Discounts cannot be applied to the membership fee.");
            }else{
                window.showMembershipPopup("Discounts cannot be applied to the membership fee.");
            } 
        } else if (result.message) {
          window.showMembershipPopup(result.message);
        }

        resetButton();
        return;
      }

      // Step 4: Success -> Open Drawer if ab_cart=drawer, else redirect to cart
      handleSuccessOrExisting();
      resetButton();

    } catch (error) {
      console.error('Error adding membership:', error);
      resetButton();
    }
    // Create the igEvents array if it doesn't exist
    window.igEvents = window.igEvents || [];
    // Add your event to the igEvents array
    window.igEvents.push({
    "event": "javascripteventRNVUC", // Do not remove - required for tracking
    })
  }

  // 1. Vanilla JS event delegation
  document.addEventListener('click', function (e) {
    const button = e.target.closest(targetSelector);
    if (!button) return;
    handleMembershipClick(e, button);
  }, true); // Capturing phase to intercept before other listeners

  // 2. jQuery event delegation if jQuery exists
  if (window.jQuery) {
    window.jQuery(document).off('click.membershipCTA', targetSelector);
    window.jQuery(document).on('click.membershipCTA', targetSelector, function (e) {
      handleMembershipClick(e, this);
    });
  }
});